// src/lib/sessionApi.js — name support + setMediaSource
import { io } from "socket.io-client";

function resolveSocketBase() {
  // 1. Dev: als de frontend op localhost draait → altijd lokale backend
  if (
    typeof window !== "undefined" &&
    window.location.hostname === "localhost"
  ) {
    return "http://localhost:5000";
  }

  // 2. Prod: bondapp.tv → productie signaling backend
  if (
    typeof window !== "undefined" &&
    window.location.hostname === "bondapp.tv"
  ) {
    return "https://signal.bondapp.tv";
  }

  // 3. Optioneel: override via env (bijv. staging)
  const ENV_SIGNALING = process.env.REACT_APP_SIGNALING_URL;
  if (ENV_SIGNALING) return ENV_SIGNALING;

  const ENV_API_BASE = process.env.REACT_APP_API_BASE;
  if (ENV_API_BASE) return ENV_API_BASE;

  // 4. Fallback (dev)
  return "http://localhost:5000";
}


export const API_URL = resolveSocketBase();

console.log("BOND SOCKET API_URL =", API_URL);

export const socket = io(API_URL, {
  autoConnect: true,
  transports: ["websocket"],
  withCredentials: true,

  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 400,
  reconnectionDelayMax: 2000,
  timeout: 8000,
});

socket.on("connect", () => console.log("[socket] connected", socket.id));
socket.on("disconnect", (r) => console.log("[socket] disconnected", r));
socket.on("reconnect_attempt", (n) => console.log("[socket] reconnect_attempt", n));
socket.on("reconnect", (n) => console.log("[socket] reconnected", n));


const listeners = new Map();

export function on(event, handler) {
  const wrapped = (...args) => handler(...args);
  socket.on(event, wrapped);
  const offs = listeners.get(event) || [];
  offs.push(wrapped);
  listeners.set(event, offs);
  return () => socket.off(event, wrapped);
}

export function createSession(payload = {}, token) {
  return new Promise((resolve) => {
    socket.emit(
      "session:create",
      { ...payload, token: token || null },
      (res) => resolve(res)
    );
  });
}

export function joinSession(code, token) {
  return new Promise((resolve) => {
    socket.emit(
      "session:join",
      { code, token: token || null },
      (res) => resolve(res)
    );
  });
}

export function leaveSession() {
  return new Promise((resolve) => {
    socket.emit("session:leave", {}, () => resolve(true));
  });
}


function makeCommandId() {
  // Browser-uuid als het kan
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}



export function mediaCommand(payload) {
  const commandId = makeCommandId();

  return new Promise((resolve) => {
    socket.emit(
      "media:command",
      { ...(payload || {}), commandId },
      (res) => resolve(res)
    );
  });
}



export function setMediaSource(payload, token) {
  // payload: { mode: "mp4" | "hls", url: string, providerId?, label? }
  return new Promise((resolve) => {
    socket.emit(
      "media:source",
      { ...payload, token: token || null },
      (res) => resolve(res)
    );
  });
}

// ✅ Pull authoritative media state (tab-switch recovery)
export function pullMediaState(code) {
  return new Promise((resolve) => {
    socket.emit("media:pull", { code }, (res) => resolve(res));
  });
}

// Optional: server time ping (debug / clock sync)
export function pingServerTime() {
  return new Promise((resolve) => {
    socket.emit("time:ping", {}, (res) => resolve(res));
  });
}
